import { render } from "./TopCoverClasses.vue?vue&type=template&id=dbf60068&scoped=true&ts=true"
import script from "./TopCoverClasses.vue?vue&type=script&lang=ts"
export * from "./TopCoverClasses.vue?vue&type=script&lang=ts"

import "./TopCoverClasses.vue?vue&type=style&index=0&id=dbf60068&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbf60068"]])

export default __exports__